module.exports = __webpack_public_path__ + "img/hvor-er-mine-likes-1.ecdfc1fc.png";